import styled from 'styled-components'

import { palette, mediaQueries } from '../../../styles/variables'
import Icon from '../../../components/icon/Icon'

export const Row = styled.div({
  display: 'flex',
  alignItems: 'flex-start',
  margin: '8px 0',
})

export const AddonsSection = styled.div({
  width: '100%',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  marginTop: '30px',
  [mediaQueries.mobile]: {
    marginTop: '15px',
  },
})

export const AddonCard = styled.div((props) => ({
  width: '100%',
  maxWidth: '1134px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '10px',
  border: `1px solid ${props.selected ? palette.orange : palette.gray50}`,
  borderRadius: '2px',
  padding: '10px 20px',
  cursor: props.clickable ? 'pointer' : 'inherit',
  [mediaQueries.mobile]: {
    flexDirection: 'column',
    padding: '5px 10px',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
}))

const AddonIconCircle = styled.div((props) => ({
  width: '38px',
  height: '38px',
  background: props.background || palette.lightGray20,
  borderRadius: '19px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  ...props.style,
}))

export const AddonIcon = ({ background, icon, style }) => {
  return (
    <AddonIconCircle background={background} style={style}>
      <Icon src={icon} />
    </AddonIconCircle>
  )
}
